<div class="about-page">

  @if (hero) {
    <section class="about-hero">

      @if (heroMediaUrl) {
        <img
          class="about-hero-background"
          [src]="heroMediaUrl"
          alt=""
          aria-hidden="true"
        />
      }

      <div class="about-hero-inner">
        <p class="about-eyebrow">About</p>

        <h1>
          {{ hero.title }}

          @if (hero.accentText) {
            <br />
            <span>{{ hero.accentText }}</span>
          }
        </h1>

        @if (hero.subtitle) {
          <p class="about-hero-sub">
            {{ hero.subtitle }}
          </p>
        }
      </div>
    </section>
  }

  <div class="about-sections">
    @for (section of sections; track section.id; let index = $index) {
      <section
        class="about-content-section"
        [class.reverse]="index % 2 !== 0"
      >
        <div class="about-section-inner">
          <div class="about-content-grid">

            <div class="about-content-text">
              <h2>{{ section.title }}</h2>

              <p class="section-body">
                {{ section.body }}
              </p>
            </div>

            @if (getSectionMediaUrl(section)) {
              <div class="about-content-image">
                <img
                  [src]="getSectionMediaUrl(section)"
                  [alt]="section.title"
                />
              </div>
            }

          </div>
        </div>
      </section>
    }
  </div>

</div>